import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
} from '../../../../../St/Reports/UseStyle';
import { Button, Hidden } from "@material-ui/core";
import { insh as inshst } from "../../../../../Context/InshSt";
import { Scanner } from "@material-ui/icons";

export default function OutstandingInvoiceForm(props) {
    const {
        rptParams,
        onChangeData,
        isPurches,
        viewHandle,
        fetching
    } = props;

    const { t } = useTranslation(["forms"]);
    const claslbl = useStylesLbl();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>

                {/* <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={isPurches ? calsPurch : clasAo}
                        value={rptParams.user}
                        onChange={(event, newValue) => {
                            onChangeAutoData("user", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions.Users}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                id="sales_emp"
                                {...params}
                                label={t("user")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                            />
                        )}
                    />
                </Grid> */}
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateFrom"
                        label={t("date-from")}
                        className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                        // InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParams.dateFrom}
                        onChange={onChangeData('dateFrom')}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    viewHandle(event);
                                }
                            },
                            className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                        }}
                    /></Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateTo"
                        label={t("date-to")}
                        className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                        // InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParams.dateTo} onChange={onChangeData('dateTo')}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    viewHandle(event);
                                }
                            },
                            className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                        }}
                    /></Grid>

                <Hidden smUp={["sm"]}>
                    <Grid item>
                        <Button
                            disabled={fetching}
                            variant="contained"
                            startIcon={<Scanner />}
                            size="large"
                            style={
                                (isPurches ? inshst.purch.iconBtn : inshst.sal.iconBtn,
                                    { borderRadius: 0 })
                            }
                            className={[clasui.button]}
                            onClick={() => viewHandle()}
                        >
                            {t("forms:show")}
                        </Button>
                    </Grid>
                </Hidden>
                <Hidden only={["xs"]}>
                    <Grid item>
                        <Button
                            disabled={fetching}
                            variant="contained"
                            startIcon={<Scanner/>}
                            size="large"
                            style={
                                (isPurches ? inshst.purch.iconBtn : inshst.sal.iconBtn,
                                    { borderRadius: 0 })
                            }
                            className={[clasui.button]}
                            onClick={() => viewHandle()}
                        >
                            {t("forms:view")}
                        </Button>
                    </Grid>
                </Hidden>

            </Grid>
        </React.Fragment>
    );
}
